import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const SliderWrapper = styled.div`
  display: block;
  position: relative;
  height: 100%;
`;

interface IArrowWrapperProps {
  isLeft: boolean;
  offset?: string;
}

export const ArrowWrapper = styled.div<IArrowWrapperProps>`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: 0;
  background-color: rgb(255, 255, 255);
  z-index: 2;

  left: ${({ isLeft, offset }) => (isLeft ? offset ?? '0' : 'unset')};
  @media (min-width: ${breakpoints.lg}) {
    left: ${({ isLeft, offset }) =>
      isLeft ? offset ?? '-1.5625rem' : 'unset'};
  }

  right: ${({ isLeft, offset }) => (isLeft ? 'unset' : offset ?? '0')};
  @media (min-width: ${breakpoints.lg}) {
    right: ${({ isLeft, offset }) =>
      isLeft ? 'unset' : offset ?? '-1.5625rem'};
  }
`;
